/* v8 - currency + analytics + debounce lock + button loading spinner */
(function () {
  console.log('[thyred] cart.js v6');

  var drawer, body, foot, totalEl;
  var currentCurrency = 'USD';

  function money(cents) {
    // IDR/JPY/KRW etc. don't use subunits — Shopify still multiplies by 100, so we divide back
    var noDecimal = ['IDR','JPY','KRW','VND','CLP','PYG','UGX','RWF','XAF','XOF','BIF','DJF','GNF','KMF','MGA','XPF'];
    var amount = cents / 100;
    var fractionDigits = noDecimal.indexOf(currentCurrency) >= 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currentCurrency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      }).format(amount);
    } catch (e) {
      return currentCurrency + ' ' + amount.toFixed(fractionDigits);
    }
  }

  function updateCount(cart) {
    var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
    document.querySelectorAll('[data-thyred-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function render(cart) {
    updateCount(cart);
    if (!body) return;
    if (cart && cart.currency) currentCurrency = cart.currency;
    if (!cart || !cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="td-drawer-empty"><p>Your cart is empty.</p><button type="button" class="btn btn-ghost" data-td-close>Continue browsing</button></div>';
      foot.hidden = true;
      return;
    }
    var html = '<ul class="td-items">';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/, '_120x120$1$2') : '';
      var sale = it.original_price > it.final_price;
      html += '<li class="td-item" data-key="' + it.key + '">';
      html += '<div class="td-item-media">' + (img ? '<img src="' + img + '" alt="' + (it.title || '') + '">' : '') + '</div>';
      html += '<div class="td-item-info">';
      html += '<a class="td-item-title" href="' + it.url + '">' + (it.product_title || it.title) + '</a>';
      if (it.variant_title && it.variant_title !== 'Default Title') {
        html += '<div class="td-item-variant">' + it.variant_title + '</div>';
      }
      html += '<div class="td-item-row">';
      html += '<div class="td-qty">';
      html += '<button type="button" class="td-qty-btn" data-td-qty="-1" data-key="' + it.key + '" aria-label="Decrease">&minus;</button>';
      html += '<span class="td-qty-val">' + it.quantity + '</span>';
      html += '<button type="button" class="td-qty-btn" data-td-qty="1" data-key="' + it.key + '" aria-label="Increase">+</button>';
      html += '</div>';
      html += '<button type="button" class="td-item-remove" data-td-remove="' + it.key + '" aria-label="Remove">Remove</button>';
      html += '</div>';
      html += '</div>';
      html += '<div class="td-item-price">';
      if (sale) {
        html += '<s>' + money(it.original_price * it.quantity) + '</s>';
      }
      html += '<span>' + money(it.final_price * it.quantity) + '</span>';
      html += '</div>';
      html += '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    totalEl.textContent = money(cart.total_price);
    foot.hidden = false;
  }

  function openDrawer() {
    drawer.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { drawer.classList.add('open'); });
    var p = drawer.querySelector('.td-drawer-panel');
    if (p) p.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.setAttribute('hidden', ''); }, 250);
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  var __addBusy = false;
  function addToCart(variantId, qty) {
    // Defensive lock: ignore repeat clicks within 800ms (prevents touch+mouse double-fire, jittery clicks, accidental dupes).
    if (__addBusy) { console.log('[thyred] add ignored (busy)'); return Promise.resolve(); }
    __addBusy = true;
    var release = function(){ setTimeout(function(){ __addBusy = false; }, 800); };
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty || 1);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Cart add failed');
        return refresh().then(function(cart){
          if (window.thyredTrackAddToCart) {
            var added = (cart.items || []).filter(function(i){return String(i.variant_id) === String(data.variant_id || variantId);})[0] || data;
            window.thyredTrackAddToCart(added, cart);
          }
          return cart;
        });
      })
      .then(openDrawer)
      .catch(function (err) {
        console.error('[thyred] add failed', err);
        window.location.href = '/cart/' + variantId + ':' + (qty || 1);
      })
      .then(release, release);
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function setBuyLoading(btn, on){
    if (!btn) return;
    if (on) {
      // Stash original markup once
      if (btn.getAttribute('data-orig-html') === null) {
        btn.setAttribute('data-orig-html', btn.innerHTML);
        var w = btn.offsetWidth, h = btn.offsetHeight;
        btn.style.minWidth = w + 'px';
        btn.style.minHeight = h + 'px';
      }
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.innerHTML = '<span class="thyred-spinner" aria-hidden="true"></span><span class="visually-hidden">Adding…</span>';
    } else {
      var orig = btn.getAttribute('data-orig-html');
      if (orig !== null) {
        btn.innerHTML = orig;
        btn.removeAttribute('data-orig-html');
      }
      btn.style.minWidth = '';
      btn.style.minHeight = '';
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  function onClick(e) {
    var buy = e.target.closest('[data-thyred-buy]');
    if (buy) {
      e.preventDefault();
      var vid = buy.getAttribute('data-variant-id');
      if (!vid) return;
      if (buy.classList.contains('is-loading')) return;
      setBuyLoading(buy, true);
      addToCart(vid, 1).then(function(){ setBuyLoading(buy, false); }, function(){ setBuyLoading(buy, false); });
      return;
    }
    if (e.target.closest('[data-td-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var toggle = e.target.closest('[data-thyred-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      refresh().then(openDrawer);
      return;
    }
    if (e.target.closest('.td-checkout')) {
      if (window.thyredTrackInitiateCheckout) {
        fetch('/cart.js').then(function(r){return r.json();}).then(window.thyredTrackInitiateCheckout);
      }
    }
    var qtyBtn = e.target.closest('[data-td-qty]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-key');
      var delta = parseInt(qtyBtn.getAttribute('data-td-qty'), 10);
      var current = parseInt(qtyBtn.parentElement.querySelector('.td-qty-val').textContent, 10);
      changeQty(key, Math.max(0, current + delta));
      return;
    }
    var rm = e.target.closest('[data-td-remove]');
    if (rm) {
      changeQty(rm.getAttribute('data-td-remove'), 0);
      return;
    }
  }

  function onKey(e) {
    if (e.key === 'Escape' && drawer && !drawer.hasAttribute('hidden')) closeDrawer();
  }

  function init() {
    drawer = document.getElementById('ThyredDrawer');
    if (!drawer) { console.warn('[thyred] drawer not in DOM'); return; }
    body = document.getElementById('ThyredDrawerBody');
    foot = document.getElementById('ThyredDrawerFoot');
    totalEl = document.getElementById('ThyredDrawerTotal');
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    refresh();
    console.log('[thyred] cart drawer ready');
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
